export default __webpack_public_path__ + "static/media/homeActive.e14edc12.svg";